"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Gmail = createSVGIcon(
  <>
    <path fill="#CCC" d="m22 6-9.75 7.697 9.237 5.645z" />
    <path
      fill="#C44D41"
      fillRule="evenodd"
      d="M20.25 7.449v11.893h1.5V6.724c0-.912-1.03-1.445-1.774-.918l-8.726 6.168-8.726-6.168a1.125 1.125 0 0 0-1.774.918v12.618h1.5V7.45l9 6.362z"
      clipRule="evenodd"
    />
  </>,
  "Gmail",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Gmail",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
  }) // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
